import { Box, TableContainer } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import * as React from 'react'
import { useQuery } from 'react-query'
import StudyService from '../../../APIs/Python/APIs/StudyService'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserContext } from '../../../Contexts/UserConfig'
import { DataCollection } from '../../../Typescript/StuartPy/DataCollection'
import { DataCollectionCols } from './DataCollectionCols'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { AxiosResponse } from 'axios'
import PageSection from '../../../Constants&Theme/PageSection'
import EntryStepsHeader from './EntryStepsHeader'

function SelectResume() {
  const { whoAmI } = useUserContext()
  const { study_id } = useParams()
  const { setError } = useMessagePopupContext()
  const navigate = useNavigate()

  const { data: collections, isLoading } = useQuery<
    DataCollection[],
    AxiosResponse
  >(
    ['StudyService', 'getStudyCollections', study_id],
    () => StudyService.getStudyCollections(whoAmI, study_id!),
    {
      enabled: !!whoAmI && !!study_id,
      onError: (err) => setError(err),
    },
  )

  return (
    <Box
      sx={{
        width: 1,
        maxWidth: 'xl',
      }}
    >
      <EntryStepsHeader step={0}>
        <PageSection title={'Select Entry to Resume'}>
          <TableContainer sx={{ width: 1 }}>
            <DataGridPro
              hideFooter
              autoHeight
              rows={
                collections ?
                  collections.map((a) => {
                    return { ...a, id: a.SpreadsheetID }
                  })
                : []
              }
              initialState={{
                sorting: {
                  sortModel: [{ field: 'StartTime', sort: 'asc' }],
                },
                columns: {
                  columnVisibilityModel: {
                    SheetsID: false,
                    SpreadsheetID: false,
                  },
                },
              }}
              columns={DataCollectionCols}
              disableColumnMenu
              loading={isLoading}
              onRowClick={(row) => navigate(`../sheet?id=${row.id}`)}
            />
          </TableContainer>
        </PageSection>
      </EntryStepsHeader>
    </Box>
  )
}

export default SelectResume
